import { render, staticRenderFns } from "./ListaLiquidaciones.vue?vue&type=template&id=483097cb"
import script from "./ListaLiquidaciones.vue?vue&type=script&lang=js"
export * from "./ListaLiquidaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports